export default {"zoomContainer":"AWjd1","preview":"GRYyY","original":"_2h9NQ","originalActive":"hqoFH","disabledMobile":"_1DXCP"};